export const findModuleByLocation = loc => {
  const [, pathnamePOS, pathnameSettings] = loc.pathname.split("/");
  return pathnamePOS !== "settings" ? pathnamePOS : pathnameSettings;
};
